

import { useDispatch, useSelector } from "react-redux";
import CheckoutFinishedView from "./view"
import { useEffect, useState } from "react";
import { clearUser } from "@/redux/ducks/user";
import { openApp, getFormattedCart } from "@/utils/functions";
import { useNavigate } from "react-router-dom";
import { ReducersTypes } from "@/redux/reducers/Models";
import useTicket from "@/hooks/useTicket";
import moment from "moment";

export default function CheckoutFinished() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state: ReducersTypes) => state.userReducer);

  const [error, setError] = useState<boolean>(false);

  const { 
    isLoading, 
    getTickets, 
    getInvoice, 
    generatePDF,
    invoice,
    toggleModal,
    isVisibleModal,
  } = useTicket();

  const toggleError = () => setError(prev => !prev);

  const goToPlayStore = () => {
    openApp("android");
  }

  const goToAppleStore = () => {
    openApp("ios");
  }

  const goToTickets = () => navigate('/ticket/pin');

  const goBack = () => navigate('/');

  const openInvoice = () => {
    getTickets(() => {
      
      const currentTickets = user?.tickets;
      const { total } = getFormattedCart({ cart: user?.cart || [], debts: user?.debts || [] });
      
      if (!currentTickets || currentTickets.length === 0) {
        toggleError();
        return;
      }
      
      const filteredItems = currentTickets?.filter(item => {
        const itemPrice = Number(item.price.replace(/,/g, '.'));
        const isPriceMatch = Math.abs(itemPrice - total) < 0.01;
        const isWithinTimeLimit = moment(item.fullDate).isAfter(moment().subtract(10, 'minutes'));

        return isPriceMatch && isWithinTimeLimit;
      }) ?? [];  
      
      if (filteredItems.length === 0) {
        const recentTickets = currentTickets?.filter(item => 
          moment(item.fullDate).isAfter(moment().subtract(10, 'minutes'))
        ) ?? [];
        
        if (recentTickets.length > 0) {
          getInvoice({
            id: recentTickets[0].id,
            date: recentTickets[0].date,
            price: recentTickets[0].price,
            status: recentTickets[0].status
          });
          return;
        }
      }
      
      const sortedTickets = [...filteredItems]?.sort((a, b) => {
        const dateA = moment(a?.fullDate);
        const dateB = moment(b?.fullDate);
        return dateB.diff(dateA);
      });
      
      if (!sortedTickets?.length) {
        toggleError();
        return;
      }
      getInvoice({
        id: sortedTickets[0].id,
        date: sortedTickets[0].date,
        price: sortedTickets[0].price,
        status: sortedTickets[0].status
      });
    });
  }

  useEffect(() => {   
    return () => {
      dispatch(clearUser());
    };
  }, []);

  return (
    <CheckoutFinishedView
      goToPlayStore={goToPlayStore}
      goToAppleStore={goToAppleStore}
      goBack={goBack}
      goToTickets={goToTickets}
      invoice={invoice}
      toggleModal={toggleModal}
      toggleModalRegister={() => {navigate('/register')}}
      generatePDF={generatePDF}
      isVisibleModal={isVisibleModal}
      isLoading={isLoading}
      openInvoice={openInvoice}
      error={error}
      toggleError={toggleError}
      handleTryAgain={() => {
        toggleError();
        openInvoice();
      }}
    />
  );
}
